import React, { useState } from "react";
import "./custom.css";
import WidgetVendorsInfo from "./WidgetVendorsInfo";
import TableBidCycleOrdemCompraV3 from "./TableBidCycleOrdemCompraV3";

const AbaDadosGerais = () => {

  const [url, setURL] = useState("");
  const [reload, setReload] = useState(false);

  if (window.location.href != url) {
    setURL(window.location.href);
    if (window.location.href.toLocaleLowerCase().includes("dadosgerais")) {
      setReload(!reload);
    };
  }

  return (
    <>
      <TableBidCycleOrdemCompraV3 reload={reload}/>
      <WidgetVendorsInfo />
    </>
  );
};

export default AbaDadosGerais;